import { usePricingServiceCustomerContainerPriceOptions } from '@hungryroot/plan';
import {
  type PricingOption,
  type ServingSize,
  type CustomerContainerPriceOptions,
} from '@hungryroot/rest';
import {
  EditRecipeNumberBlock,
  type EditRecipeNumberBlockProps,
} from '../EditRecipeNumberBlock/EditRecipeNumberBlock';

interface GetPricePerServingParams {
  numLunch: number;
  numDinner: number;
  priceOptions: CustomerContainerPriceOptions;
  servingSize: ServingSize;
}

const getPricePerServing = ({
  numLunch,
  numDinner,
  priceOptions,
  servingSize,
}: GetPricePerServingParams) => {
  const totalQuantity = numLunch + numDinner;
  const priceOption = priceOptions.pricing_options.find(
    (option: PricingOption) => {
      return (
        option.RECIPE_QUANTITY !== null &&
        option.RECIPE_QUANTITY.quantity === totalQuantity &&
        option.RECIPE_QUANTITY.serving_size === servingSize
      );
    }
  );

  const recipeQuantity = priceOption?.['RECIPE_QUANTITY'];
  if (recipeQuantity === null) {
    return undefined;
  }
  return recipeQuantity;
};

type EditRecipeNumberBlockContainerProps = {
  customerId: number;
  containerId: number;
  initialValues?: {
    dinnerRecipes: number;
    lunchRecipes: number;
  };
  servingSize: ServingSize;
};

export const EditRecipeNumberBlockContainer = (
  props: EditRecipeNumberBlockContainerProps &
    Omit<EditRecipeNumberBlockProps, 'onClick'>
) => {
  const { customerId, containerId, initialValues, servingSize } = props;
  const { data: priceOptions, isLoading: isPriceOptionsLoading } =
    usePricingServiceCustomerContainerPriceOptions({
      customerId,
      containerId,
    });

  if (isPriceOptionsLoading || !priceOptions) {
    return null;
  }

  const { lunchRecipes, dinnerRecipes } = initialValues;

  return (
    <EditRecipeNumberBlock
      {...props}
      pricePerServing={
        // needs to be updated for correct logic
        Number(
          getPricePerServing({
            numLunch: lunchRecipes,
            numDinner: dinnerRecipes,
            priceOptions,
            servingSize,
          })?.price_per_serving
        )
      }
      onClick={({
        numLunch,
        numDinner,
      }: {
        numDinner: number;
        numLunch: number;
      }) => {
        return Promise.resolve(
          getPricePerServing({ numLunch, numDinner, priceOptions, servingSize })
        );
      }}
    ></EditRecipeNumberBlock>
  );
};
